import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { Container, Button, Grid, Typography } from "@mui/material";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import ListAltIcon from "@mui/icons-material/ListAlt";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import DoneAllIcon from "@mui/icons-material/DoneAll";
import StorageIcon from "@mui/icons-material/Storage";
import DraftsIcon from '@mui/icons-material/Drafts';
import { useNavigate } from "react-router-dom";
import OnlineSyncModal from "./OnlineSyncModal";
import StorageStatusModal from "./StorageStatusModal";
import useNetworkStatus from "../../hooks/useNetworStatus";

const PreHome = ({ handleLogout, homePageCounts, getAllCounts, openSyncDialog, setConfirmDialog = () => { }, setOpenSyncDialog = () => { } }) => {
  const [openStorageDialog, setOpenStorageDialog] = useState(false);
  const isOnline = useNetworkStatus()

  
  const history = useNavigate();
  const handleClick1 = () => {
    history("/home");
  };

  const handleClick2 = () => {
    history("/unsync-entry");
  };

  const handleClick3 = async () => {
    if (!isOnline) {
      setConfirmDialog({ open: true, text: "There is no network connection, so we couldn't fetch the latest forms.", type: "info", buttonText: "Close"})
      return
    }
    setOpenSyncDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenSyncDialog(false);
  };

  const handleCloseStorageDialog = () => {
    setOpenStorageDialog(false);
  };

  const handleClick4 = () => {
    history("/sync-entry");
  };

  const handleDraftsSelection = () =>{
    history("/drafts");
  }

  const handleClick5 = () => {
    setOpenStorageDialog(true);
  };

  useEffect(() => {
    getAllCounts()
  }, [])

  return (
    <Container
      sx={{
        display: "flex",
        justifyContent: "center",
        minHeight: `calc(100vh - 64px)`,
        width: "100%",
        padding: { xs: "12px", sm: "100px" },
      }}
    >
      <Grid
        container
        spacing={6}
        direction="column"
        alignItems="center"
        sx={{
          width: { xs: "100%", sm: "75%" },
          marginTop: "20px",
        }}
      >
        <Grid item sx={{ width: "100%" }}>
          <Button
            variant="contained"
            startIcon={<PlayArrowIcon />}
            sx={{ width: "100%", padding: 2, justifyContent: "flex-start" }}
            onClick={handleClick1}
          >
            Start data collection
          </Button>
        </Grid>
        <Grid item sx={{ width: "100%" }}>
          <Button
            variant="contained"
            startIcon={<DraftsIcon/>}
            sx={{ width: "100%", padding: 2, justifyContent: "flex-start" }}
            onClick={handleDraftsSelection}
          >
            Drafts
             ({homePageCounts?.draftCount})
          </Button>
        </Grid>
        <Grid item sx={{ width: "100%" }}>
          <Button
            variant="contained"
            startIcon={<ListAltIcon />}
            sx={{ width: "100%", padding: 2, justifyContent: "flex-start" }}
            onClick={handleClick2}
          >
            Unsynced Forms
             ({homePageCounts?.syncCount})
          </Button>
        </Grid>
        <Grid item sx={{ width: "100%" }}>
          <Button
            variant="contained"
            startIcon={<CloudDownloadIcon />}
            sx={{ width: "100%", padding: 2, justifyContent: "flex-start" }}
            onClick={handleClick3}
          >
            Fetch latest form
          </Button>
        </Grid>
        <Grid item sx={{ width: "100%" }}>
          <Button
            variant="contained"
            startIcon={<DoneAllIcon />}
            sx={{ width: "100%", padding: 2, justifyContent: "flex-start" }}
            onClick={handleClick4}
          >
            Synced forms
          </Button>
        </Grid>
        <Grid item sx={{ width: "100%" }}>
          <Button
            variant="contained"
            startIcon={<StorageIcon />}
            sx={{ width: "100%", padding: 2, justifyContent: "flex-start" }}
            onClick={handleClick5}
          >
            Storage Status
          </Button>
        </Grid>
      </Grid>
      <OnlineSyncModal
        open={openSyncDialog}
        onClose={handleCloseDialog}
        handleLogout={handleLogout}
      />
      <StorageStatusModal
        open={openStorageDialog}
        handleClose={handleCloseStorageDialog}
      />
    </Container>
  );
};

export default PreHome;
